<template>
  <ListView
    :items="listings"
    :selected-item-id="selectedId"
    @select="selectListing"
    @highlight="id => $emit('highlight', id)"
    @unhighlight="id => $emit('unhighlight', id)"
    v-bind="$attrs"
  >
    <template #item="{item}">
      <ListingItemView
        :value="item"
        @street_view="$emit('street_view', item.id)"
      />
    </template>
  </ListView>
</template>

<script>
import ListingItemView from "@/components/ListingItemView";
import ListView from "@/components/common/ListView.vue";

export default {
  components: {ListView, ListingItemView},
  props: {
    listings: Array,
    selectedId: String,
    query: String
  },
  emits: ['street_view', 'select', 'highlight', 'unhighlight'],
  methods: {
    selectListing(id) {
      this.$emit('select', id);
    }
  }
}
</script>
